import { RSet } from "../../collections";
import { makeImmutable, Tristate } from "../../core";
import { ParameterMultiSet } from "../Menu";
import { Availability } from "./Availability";
/*
 * Availability strategy based on Ordering Hours
 */
export class OrderingHoursAvailability {
    constructor(params) {
        this.now = params.now;
        this.orderingHours = params.orderingHours;
        this.allowOrderingInClosedRestaurant =
            params.onlineOrderingSettings.allowOrderingInClosedRestaurant;
        this.fulfillmentTime = params.fulfillmentTime;
        makeImmutable(this);
    }
    get availability() {
        const canOrderNow = this.orderingHours.canOrderAt(this.now);
        if (canOrderNow) {
            return Availability.available();
        }
        if (this.canPreorder) {
            return Availability.available();
        }
        return {
            isAvailable: Tristate.False,
            unavailabilityReasons: RSet.singleton("OrderingHours"),
            causingParameters: ParameterMultiSet.empty(),
            errors: ["OrderingHours"],
        };
    }
    get isOutOfOrderingHours() {
        return !this.orderingHours.canOrderAt(this.now);
    }
    get canPreorder() {
        if (this.isOutOfOrderingHours && !this.allowOrderingInClosedRestaurant) {
            return false;
        }
        return this.fulfillmentTime.hasAnyAvailableTime;
    }
}
